import { MagnifyingGlassIcon } from '../../assets/images/components';
import './UnsuccessfulSearch.scss';

const UnsuccessfulSearch = ({
  paddingTop,
  customText,
  hideIcon,
  customClassName = '',
  customTextClassName = ''
}: {
  paddingTop?: number;
  customText?: string;
  hideIcon?: boolean;
  customClassName?: string;
  customTextClassName?: string;
}) => {
  const paddingTopStyles = { paddingTop: `${paddingTop ?? 136}px` };
  const defaultText = 'No hay resultados para tu búsqueda';

  return (
    <div className={`unsuccessfulSearch ${customClassName}`} style={paddingTopStyles}>
      {!hideIcon && (
        <div className="magnifierIconContainer">
          <img src={MagnifyingGlassIcon} alt="Lupa" />
        </div>
      )}
      <div className={`text ${customTextClassName}`}>{customText || defaultText}</div>
    </div>
  );
};

export default UnsuccessfulSearch;
